import type * as Types from '@precon-tools-suite-by-shared/precon-graphql-types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type NodesTagsNextPageQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
}>;


export type NodesTagsNextPageQuery = {
  __typename: 'Query',
  node?: {
    __typename: 'AddressFormat',
    id: string
  } | {
    __typename: 'AnalysisReport',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'AnalysisReportEntry',
    id: string
  } | {
    __typename: 'AnalysisReportEntryProbabilityOverwriteEvent',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'AnalysisReportEntrySeverityOverwriteEvent',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'AnalysisReportProductRisk',
    id: string
  } | {
    __typename: 'AssignProductCategoryToProductTodo',
    id: string
  } | {
    __typename: 'AssignSupplierBranchToProductTodo',
    id: string
  } | {
    __typename: 'Client',
    id: string
  } | {
    __typename: 'Comment',
    id: string
  } | {
    __typename: 'Company',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'Contact',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'Country',
    id: string
  } | {
    __typename: 'EchoFilesJob',
    id: string
  } | {
    __typename: 'ExportAnalysisReportEntriesJob',
    id: string
  } | {
    __typename: 'ExportProductsSpreadsheetJob',
    id: string
  } | {
    __typename: 'ExportSupplierBranchesSpreadsheetJob',
    id: string
  } | {
    __typename: 'ExportSupplierVCardsJob',
    id: string
  } | {
    __typename: 'ExportSuppliersSpreadsheetJob',
    id: string
  } | {
    __typename: 'File',
    id: string
  } | {
    __typename: 'GeneralAudit',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'Notification',
    id: string
  } | {
    __typename: 'PhoneNumberFormat',
    id: string
  } | {
    __typename: 'Product',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'ProductCategory',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'ProductCategoryAudit',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'ProductPredicateRequirement',
    id: string
  } | {
    __typename: 'ProvideRequiredProductPredicateValuesTodo',
    id: string
  } | {
    __typename: 'QuestionPredicate',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'Region',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'ResolveAnalysisReportProductRiskPredicateValueTodo',
    id: string
  } | {
    __typename: 'Risk',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'RiskAudit',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'RiskColumn',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'RiskConfiguration',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'RiskConfigurationLevel',
    id: string
  } | {
    __typename: 'RiskConfigurationProbability',
    id: string
  } | {
    __typename: 'RiskConfigurationSeverity',
    id: string
  } | {
    __typename: 'RiskProbabilityAudit',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'SelectAnalysisReportProductsTodo',
    id: string
  } | {
    __typename: 'SetRiskProbabilityValueForRiskConfigurationTodo',
    id: string
  } | {
    __typename: 'SetThreatSeverityValueForRiskConfigurationTodo',
    id: string
  } | {
    __typename: 'Supplier',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'SupplierBranch',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'SupplierReliability',
    id: string
  } | {
    __typename: 'Tag',
    id: string
  } | {
    __typename: 'Team',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'TeamLicense',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'TeamLicenseClass',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'Threat',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'ThreatAudit',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'ThreatCategory',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'ThreatCategoryAudit',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'ThreatSeverityAudit',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'User',
    id: string
  } | {
    __typename: 'UserInvitation',
    id: string
  } | {
    __typename: 'VerificationAction',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'VerificationConfiguration',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'VerificationConfigurationRule',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | {
    __typename: 'VerificationPredicate',
    id: string,
    tags?: {
      __typename: 'TagConnection',
      totalCount?: number | null,
      pageInfo: {
        __typename: 'PageInfo',
        hasNextPage: boolean,
        endCursor?: string | null
      },
      edges?: Array<{
        __typename: 'TagEdge',
        cursor: string,
        node: {
          __typename: 'Tag',
          id: string,
          description?: string | null,
          icon?: Types.TagIcon | null,
          color?: Types.Color | null,
          name?: {
            __typename: 'Name',
            full?: string | null,
            short?: string | null
          } | null
        }
      } | null> | null
    } | null
  } | null
};

export type TagNodeMutationVariables = Types.Exact<{
  input: Types.AttachTagsInput;
}>;


export type TagNodeMutation = {
  __typename: 'Mutation',
  attachTags: {
    __typename: 'AttachTags_SuccessResult'
  }
};

export type UntagNodeMutationVariables = Types.Exact<{
  input: Types.DetachTagsInput;
}>;


export type UntagNodeMutation = {
  __typename: 'Mutation',
  detachTags: {
    __typename: 'DetachTags_SuccessResult'
  }
};


export const NodesTagsNextPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NodesTagsNextPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"5"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}},"defaultValue":{"kind":"NullValue"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Taggable"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full"}},{"kind":"Field","name":{"kind":"Name","value":"short"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NodesTagsNextPageQuery, NodesTagsNextPageQueryVariables>;
export const TagNodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TagNode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AttachTagsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachTags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<TagNodeMutation, TagNodeMutationVariables>;
export const UntagNodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UntagNode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DetachTagsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"detachTags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UntagNodeMutation, UntagNodeMutationVariables>;